/* eslint semi: "off" */
/* eslint react/jsx-filename-extension: "off" */
/* eslint react/prop-types: "off" */
/* eslint no-console: "off" */
/* eslint jsx-a11y/click-events-have-key-events: "off" */
/* eslint jsx-a11y/no-noninteractive-element-interactions: "off" */
/* eslint jsx-a11y/anchor-has-content: "off" */
/* eslint react/no-multi-comp: "off" */
/* eslint no-underscore-dangle: "off" */
import React from 'react';
import ReactDOM from 'react-dom';

import { StateProvider } from './components/stateProvider/stateProvider';
import reducer, { initialState } from './store/reducer';

import { Provider } from 'react-redux';

// import * as firebase from 'firebase/app';
// import firebase from 'firebase/app'
import firebase from 'firebase';
import 'firebase/auth';
import 'firebase/database';

import { ReactReduxFirebaseProvider } from 'react-redux-firebase';

// import { ConnectedRouter /* , push */ } from 'react-router-redux';
import { ConnectedRouter } from 'connected-react-router'
// import createHistory from 'history/createBrowserHistory';

import configureStore, { rrfConfig, contextA } from './redux/store/configureStore';

import './index.css';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';

// Initialize store
const history = require('history').createBrowserHistory();

const store = configureStore(history);

const auth = firebase.auth();
// const auth = Auth.auth();

// const app = firebase.app()


auth.onAuthStateChanged((user) => {
  // console.log('onAuthStateChanged', user);
  // console.log('app', auth.app);
  if (user) {
    // TODO: fix multiple actions types
    store.dispatch({ type: 'AUTH_LOGGED', payload: user });
    store.dispatch({ type: 'AUTH_LOG_SUCCESS', payload: user });
    store.dispatch({ type: 'AUTH_LOG_SUCCESS', payload: user });
    // store.dispatch(push('/app/dashboard'))
  } else {
    // this.props.dispatch({type: 'AUTH_NOT_LOGGED'})
    store.dispatch({ type: 'AUTH_NOT_LOGGED' });
    store.dispatch({ type: 'AUTH_LOGOUT_SUCCESS' });
    // store.dispatch(push('/login'))

    console.log('NOT CONNECTED');
  }
});

window.addEventListener('beforeunload', (ev) => {
  ev.preventDefault();
  return ev.returnValue = 'Are you sure you want to close?';
});


firebase.auth().signInAnonymously();

const ref = firebase.database().ref('/partners');
ref.on('value', (data) => {
  console.log('::::::::: ', data);
  data.forEach((item) => {
    console.log(`:::: ${item.key} ${item.val().name}`);
  });
});

const rrfProps = {
  firebase,
  config: rrfConfig,
  dispatch: store.dispatch,
}


console.log('::::: reducer', reducer, ref);
ReactDOM
  .render(
    <React.StrictMode>
      <StateProvider initialState={initialState} reducer={reducer}>
        <Provider store={store} context={contextA}>
          <ReactReduxFirebaseProvider {...rrfProps}>
            <ConnectedRouter history={history} context={contextA} >
              <App history={history} context={contextA} />
            </ConnectedRouter>
          </ReactReduxFirebaseProvider>
        </Provider>
      </StateProvider>
    </React.StrictMode>,
    document.getElementById('root'),
  );
// temporary disabled
// registerServiceWorker();




// WEBPACK FOOTER //
// ./src/index.js